
import React from 'react'
import Modal from '@material-ui/core/Modal'
import AddIcon from '@material-ui/icons/Add'
import RaisedButton from 'material-ui/RaisedButton';
import AppBar from '@material-ui/core/AppBar'
const IdleTimeOutModal = props => {
          return (
                    <Modal
                              open={props.open}
                              close={props.onClose}
                              style={{margin:"auto"}}>
                              <div
                                        className="col-sm-12 flow-modal"
                                        style={container}>
                                      
                                        <AppBar
                                                  position="static"
                                                  style={{ background: '#e80d04' }}>
                                                  <div className="modal-header">
                                                            <h6
                                                                      className="modal-title"
                                                                      id="exampleModal">
                                                                      You have been Idle!
                                                             </h6>
                                                            <AddIcon
                                                                      onClick={props.onClose}
                                                                      style={{ transform: 'rotate(45deg)', color: '#eee', cursor: 'pointer' }} />
                                                  </div>
                                        </AppBar>
                                        <div className="modal-body" style={{}}>
                                                  You Will Get Timed Out. You want to stay?
                                        </div>
                                        <div
                                                  className="col-sm-12 text-center"
                                                  style={{ marginTop: "16px",marginBottom:"10px", fontWeight: "600" }}>
                                                  <RaisedButton
                                                            className="btn-std"
                                                            label="Logout"
                                                            backgroundColor="#000000"
                                                            labelColor="#ffffff"
                                                            data-dismiss="modal"
                                                            onClick={props.handleLogout}
                                                  />
                                                  <RaisedButton
                                                     
                                                            label="Stay"
                                                            className=" ml-4 btn-std"
                                                            backgroundColor="#000000"
                                                            labelColor="#ffffff"
                                                            data-dismiss="modal"
                                                            onClick={props.onClose}
                                                  />
                                        </div>
                              </div>
                    </Modal>
          )
}




const container = {
          // marginTop: '20px',
          background: '#fff',
          width: '25%',
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          margin:"auto",
          left:"40%",
          top:"35%",
          padding: "0px",
}

export default IdleTimeOutModal


// WEBPACK FOOTER //
// ./src/components/navigation/idleModal.jsx